import { Injectable } from '@angular/core';
import { BacklightService } from 'src/app/components/pages/page-device-settings/children/subpage-device-settings-input-accessory/backlight/backlight.service';
import { LocalStorageKey } from 'src/app/enums/local-storage-key.enum';
import { EMachineType } from 'src/app/enums/machine-type.enum';
import { CommonService } from 'src/app/services/common/common.service';
import { LoggerService } from 'src/app/services/logger/logger.service';

@Injectable({
	providedIn: 'root',
})
export class KeyboardBacklightFeature {
	constructor(
		private backlightService: BacklightService,
		private commonService: CommonService,
		private logger: LoggerService
	) {}

	public async getCapabililty(): Promise<boolean> {
		const machineType: EMachineType = this.commonService.getLocalStorageValue(
			LocalStorageKey.MachineType
		);
		let hasCapability = false;

		if (machineType == EMachineType.IdeaPad || machineType == EMachineType.ThinkPad) {
			hasCapability = await this.checkCapability();
		}

		return hasCapability;
	}

	private async checkCapability(): Promise<boolean> {
		let hasCapability = false;
		hasCapability = await this.backlightService.getCapability();

		this.commonService.setLocalStorageValue(LocalStorageKey.BacklightCapability, hasCapability);
		this.logger.info('KeyboardBacklightFeatureForIdeapadCapability', hasCapability);

		return hasCapability;
	}
}
